import { render } from "./cardSTT.vue?vue&type=template&id=10942e5c&scoped=true&ts=true"
import script from "./cardSTT.vue?vue&type=script&lang=ts"
export * from "./cardSTT.vue?vue&type=script&lang=ts"

import "./cardSTT.vue?vue&type=style&index=0&id=10942e5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10942e5c"]])

export default __exports__